import { RoleSelection } from '../roles.types';
import { RoleSelectionViewModel } from '../../../apollo/queries/getAllRoles.queries';

interface CategoryFilterArgs {
  orgCode: string;
  roles: RoleSelection[];
  roleSelectionViewModel: RoleSelectionViewModel[];
}

const filterRolesByOrgCode = (orgCode: string, roles: RoleSelection[]) =>
  roles.reduce((acc: string[], role: RoleSelection) => {
    if (role.org === orgCode) {
      return [...acc, role.name];
    }
    return acc;
  }, []);

const getCategoriesForSelectedRolesByOrg = ({
  roleSelectionViewModel,
  orgCode,
  roles,
}: CategoryFilterArgs) => {
  const selectedRoles = filterRolesByOrgCode(orgCode, roles);

  const findMatchingCategories = (acc: string[], c: any) => {
    const isExist = c.roles.find((r: any) => selectedRoles.includes(r.name));
    if (isExist) {
      return [...acc, c.categoryName];
    }
    return acc;
  };

  const categories = roleSelectionViewModel.reduce((acc: string[], section) => {
    const { categories } = section;
    const matchingCategories = categories.reduce(findMatchingCategories, []);

    return [...acc, ...matchingCategories];
  }, []);

  return [...categories];
};

export default getCategoriesForSelectedRolesByOrg;
